
export const setCameraRotation = (x, y) => {

    return {
        type: "CAMERA_ROTATION_CHANGE",
        x: x,
        y: y,
    }
}



// WEBPACK FOOTER //
// ./src/actions/camera.js